import { faThumbtack } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card } from "~/components/Card";
import { Company } from "~/constants/companies";

interface CompanyCardProps {
  company: Company;
}

export const CompanyInfoCard = ({ company }: CompanyCardProps) => {
  return (
    <Card className="gap-10">
      <div className="h-full my-auto">
        <FontAwesomeIcon width={20} icon={faThumbtack} size="sm" />
      </div>
      <div className="text-gray-300">
        <p>
          <strong>Remote friendly?</strong> {company.remote}
        </p>
        <p>
          <strong>Employees:</strong> {company.employees}
        </p>
      </div>
    </Card>
  );
};
